// extracted by mini-css-extract-plugin
export default {"container":"Wk-z","blurb":"Xk-z","links":"Yk-z"};